var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "news_w" },
    [
      _c("div", { staticClass: "banner" }, [
        _c("img", { class: _vm.bannerImageClass }),
        _vm._v(" "),
        _c("div", { class: _vm.bannerTextClass }),
      ]),
      _vm._v(" "),
      _c("characteristicsList", {
        attrs: { num: _vm.num, "course-name": _vm.courseName },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }